// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext} from 'react';
import cn from 'classnames';
// @ts-ignore
import {url2md5} from 'pub_config';
import {Button, i_button_props} from '../../../shared/button';
import {Link} from './link';
import {Settings_context} from '../settings_ctx';
import {use_translation_v} from '../lib/trans_v';

import styles from './cards.module.less';

export interface i_card {
    id: string;
    title: string | JSX.Element;
    text: string | JSX.Element;
    img?: string | JSX.Element;
    img_wrapper_cls?: string;
    btn?: i_button_props;
    to?: string;
    clickid?: string;
    new_tab?: boolean;
    on_click?: ()=>void;
}
export interface i_cls_obj {
    container?: string;
    cards_wrapper?: string;
    cards_spacer?: string;
    card?: string;
    title?: string;
    text?: string;
    img?: string;
}
interface i_cards_props {
    cards: i_card[];
    cls?: i_cls_obj;
    spacer?: JSX.Element;
    group_by_two?: boolean;
}
interface i_card_props {
    card_props: i_card;
    index: number;
    cls: i_cls_obj;
    group_by_two: boolean;
}

const Card = ({card_props, index, cls, group_by_two}: i_card_props)=>{
    const {id, title, text, img, btn, to, clickid, new_tab, img_wrapper_cls,
        on_click} = card_props;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const img_content = typeof img == 'string' ?
        <img className={cn('lazyload', cls.img)}
          alt={`How Hola VPN works: step ${index + 1}`}
          data-src={url2md5(`/www/hola/pub/img/${img}`)}/> : img;
    const card_content = <Fragment>
      {img_content && <div className={cn(styles.img, cls.img,
        img_wrapper_cls && img_wrapper_cls)}>
        {img_content}
        </div>}
      {group_by_two ? <div className={styles.text_wrapper}>
        {title && <p className={cn(styles.title, cls.title)}>
          <T>{title}</T></p>}
        {text && <div className={cn(styles.text, theme.P, cls.text)}>
          <T>{text}</T>
        </div>}
      </div> : <>
        {title && <p className={cn(styles.title, cls.title, theme.p16)}>
          <T>{title}</T></p>}
        {text && <div className={cn(styles.text, theme.P, cls.text)}>
          <T>{text}</T>
        </div>}
      </>}
      {btn && <Button {...btn} />}
    </Fragment>;
    return to ? <Link to={to} className={cn(styles.card, cls.card)}
      data-clickid={clickid} data-id={id}
      target={new_tab ? '_blank' : undefined}
      rel={new_tab ? 'noopener noreferrer' : undefined}>
      {card_content}
    </Link> : <div className={cn(styles.card, cls.card,
      on_click && styles.pointer)} data-id={id} onClick={on_click}>
      {card_content}
    </div>;
};

export const Cards = (props:i_cards_props)=>{
    const {cards, cls = {}, spacer, group_by_two = false} = props;
    return <div className={cn(styles.cards, cls.container,
      group_by_two && styles.cards_column)}>
      {group_by_two ?
        cards.reduce((acc, card, i)=>{
            if (i % 2 == 0)
                acc.push([card]);
            else
              acc[acc.length - 1].push(card);
            return acc;
        }, []).map((card_pair, idx)=>{
          return <Fragment key={`pair_${idx}`}>
            <div className={styles.card_pair}>
              {card_pair.map((card_props, i)=>{
                return <Card key={card_props.id} card_props={card_props}
                  index={idx * 2 + i} cls={cls} group_by_two={group_by_two} />;
              })}
            </div>
            {idx < Math.ceil(cards.length / 2) - 1 && spacer}
          </Fragment>;
        }) :
        cards.map((card_props, i)=>{
          return <Fragment key={card_props.id}>
            <Card card_props={card_props} index={i} cls={cls}
              group_by_two={group_by_two} />
            {i<cards.length-1 && spacer}
          </Fragment>;
      })}
    </div>;
};
